import styled from "styled-components";
import colors from "../../../theme/colors";
export interface INavBarItem {
  selectedSettingsPage: string;
  setSelectedSettingsPage: React.Dispatch<React.SetStateAction<string>>;
  settingsPage: { title: string; value: string };
}

const Container = styled.li`
  color: ${(props) => props.theme.colors.body};
  width: fit-content;
  margin-left: 24px;
  margin-right: 32px;
  margin-top: 9px;
  cursor: pointer;
  padding: 10px 11px 12px 10px;
  overflow: hidden;
  border-radius: 8px;

  :hover {
    background-color: ${(props) => props.theme.colors.background};
    color: ${(props) => props.theme.colors.title};
  }
`;

const NavBarItem: React.FC<INavBarItem> = ({
  selectedSettingsPage,
  setSelectedSettingsPage,
  settingsPage,
}) => {
  return (
    <Container
      onClick={() => setSelectedSettingsPage(settingsPage.value)}
      style={{
        backgroundColor: `${
          selectedSettingsPage === settingsPage.value ? colors.background : colors.white
        }`,
        border: `1px solid ${
          selectedSettingsPage === settingsPage.value ? colors.line : colors.white
        }`,
      }}
    >
      {settingsPage.title}
    </Container>
  );
};

export default NavBarItem;
